import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function MeetingPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-6 px-6">
      <div className="max-w-5xl mx-auto">
        <Link to="/" className="inline-flex items-center text-gray-600 hover:text-accent mb-3">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Home
        </Link>
        
        <div className="flex items-center gap-4 mb-4">
          <img 
            src="https://customer-assets.emergentagent.com/job_df6f992c-82a6-44fb-a88f-450c0ac99b5b/artifacts/cvze4lab_q2y0upqj_75c9mfk0_Square%20Logo%20%28100%20x%20100%29.png" 
            alt="Ethical Wiki" 
            className="w-10 h-10"
            width="40"
            height="40"
          />
          <div>
            <h1 className="font-heading text-2xl text-gray-900">Schedule a Meeting</h1>
            <p className="text-gray-600 text-sm">Book a 30-minute Zoom call with Ethical Wiki</p>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
          <iframe
            src="https://cal.com/ethicalwiki/zoom?duration=30&embed=true&hideBranding=true"
            width="100%"
            height="700"
            frameBorder="0"
            title="Schedule a meeting"
            className="w-full"
          />
        </div>

        <div className="text-center text-gray-500 text-sm mt-4">
          <p>Having trouble with the calendar? <a href="https://cal.com/ethicalwiki/zoom?duration=30" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">Open in new tab</a></p>
        </div>
      </div>
    </div>
  );
}
